var _path, _line, _line2, _line3, _line4, _line5, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconMovementsTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m47.95,12.01c2.23,0,4.04,1.81,4.04,4.04v31.91c0,2.23-1.81,4.04-4.04,4.04h-31.91c-2.23,0-4.04-1.81-4.04-4.04v-31.91c0-2.23,1.81-4.04,4.04-4.04h31.91m0-4h-31.91c-4.44,0-8.04,3.6-8.04,8.04v31.91c0,4.44,3.6,8.04,8.04,8.04h31.91c4.44,0,8.04-3.6,8.04-8.04v-31.91c0-4.44-3.6-8.04-8.04-8.04h0Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 23.94,
    y1: 8.01,
    x2: 23.94,
    y2: 55.99,
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "2.42px"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 40.06,
    y1: 8.01,
    x2: 40.06,
    y2: 55.99,
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "2.42px"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 8.01,
    y1: 19.83,
    x2: 55.99,
    y2: 19.83,
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "2.42px"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 8.01,
    y1: 31.35,
    x2: 55.99,
    y2: 31.35,
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "2.42px"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 8.01,
    y1: 42.86,
    x2: 55.99,
    y2: 42.86,
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "2.42px"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m16.12,8.01h31.75c4.48,0,8.11,3.64,8.11,8.11v3.71H8.01v-3.71c0-4.48,3.64-8.11,8.11-8.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconMovementsTable);
export default __webpack_public_path__ + "static/media/SDS_icon_MovementsTable.e67e9b1b47349b4c95b42f7d26aa88cb.svg";
export { ForwardRef as ReactComponent };